import Isotope from 'isotope-layout';
import React, { useEffect, useState } from 'react';
import PhotoGalleryItem from './PhotoGalleryItem';


const GalleryPhotos = () => {
    const GalleryData = [
        {
            id: '1',
            category: 'Drinks',
            itemName: 'Coffee Dalgona',
            img: 'images/portfolio/1.jpg',
            tag: 'img-30 drinks'
        },
        // {
        //     id: '2',
        //     category: 'Drinks',
        //     itemName: 'Coffee Dalgona',
        //     img: 'images/portfolio/2.jpg',
        //     tag: 'img-40 coffee'
        // },
        {
            id: '3',
            category: 'Drinks',
            itemName: 'Coffee Dalgona',
            img: 'images/portfolio/3.jpg',
            tag: 'img-30 dessert'
        },
        {
            id: '4',
            category: 'Drinks',
            itemName: 'Coffee Dalgona',
            img: 'images/portfolio/4.jpg',
            tag: 'img-30 stake drinks'
        },
        {
            id: '5',
            category: 'Drinks',
            itemName: 'Coffee Dalgona',
            img: 'images/portfolio/5.jpg',
            tag: 'img-30 stake coffee'
        },
        // {
        //     id: '6',
        //     category: 'Drinks',
        //     itemName: 'Coffee Dalgona',
        //     img: 'images/portfolio/7.jpg',
        //     tag: 'img-70 dessert'
        // },
        {
            id: '7',
            category: 'Drinks',
            itemName: 'Coffee Dalgona',
            img: 'images/portfolio/6.jpg',
            tag: 'img-30 drinks'
        },
        {
            id: '8',
            category: 'Drinks',
            itemName: 'Coffee Dalgona',
            img: 'images/portfolio/8.jpg',
            tag: 'img-30 coffee'
        },
        {
            id: '9',
            category: 'Drinks',
            itemName: 'Coffee Dalgona',
            img: 'images/portfolio/10.jpg',
            tag: 'img-30 seafood'
        },
        {
            id: '10',
            category: 'Drinks',
            itemName: 'Coffee Dalgona',
            img: 'images/portfolio/9.jpg',
            tag: 'img-30 seafood'
        },
    ];

    const [filterKey, setFilterKey] = useState('*')

    // initialize an Isotope object with configs
    useEffect(() => {
        Isotope.current = new Isotope('.grid-masonary', {
            // itemSelector: '.label_text',
            layoutMode: 'fitRows',
            itemSelector: '.grid-item ',
            percentPosition: true,
            // layoutMode: 'packery',
            transformsEnabled: true,
            transitionDuration: "700ms",
            fitWidth: true,
            columnWidth: '.grid-sizer',
        })
        // cleanup
        return () => Isotope.current.destroy()
    }, [])

    // handling filter key change
    useEffect(() => {
        filterKey === '*'
            ? Isotope.current.arrange({ filter: `*` })
            : Isotope.current.arrange({ filter: `.${filterKey}` })
    }, [filterKey]);

    const handleFilterKeyChange = key => () => setFilterKey(key)

    return (
        <div className="main-wrapper">
            <div className="container">
                <div className="portfolio_grid">
                    <div className="portfolio_filters_button_content">
                        <div className="button-group filters-button-group">
                            <button className="button is-checked" onClick={handleFilterKeyChange('*')}>All</button>
                            <button className="button" onClick={handleFilterKeyChange('drinks')}>Drinks</button>
                            <button className="button" onClick={handleFilterKeyChange('dessert')}>Dessert</button>
                            <button className="button" onClick={handleFilterKeyChange('coffee')}>Coffee</button>
                            <button className="button" onClick={handleFilterKeyChange('stake')}>Stake</button>
                            <button className="button" onClick={handleFilterKeyChange('seafood')}>Seafood</button>
                        </div>
                    </div>
                    <div className="grid-masonary gutter-15 clearfix">
                        <div className="grid-sizer"></div>
                        {
                            GalleryData.map(data => <PhotoGalleryItem
                                key={data.id}
                                data={data}
                            />)
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GalleryPhotos;